module.exports = __webpack_public_path__ + "img/guide_Android.65ac7c7d.png";